'use strict';

var SettingsActions = function SettingsActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('SettingsActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'AddAnotherUser',
    purpose: 'Go back to the invitation form',
    payload: ['user']
  });

  Actions.add({
    name: 'CloseDetailView',
    purpose: 'Go back to the overview view',
    payload: ['']
  });

  Actions.add({
    name: 'OpenDetailView',
    purpose: 'Alerts overview that detail view is open',
    payload: ['']
  });

  Actions.add({
    name: 'OpenDialog',
    purpose: 'Open dialog with instruction',
    payload: ['view', 'data']
  });

  Actions.add({
    name: 'ResetPassword',
    purpose: 'Reset password',
    payload: ['user']
  });

  Actions.add({
    name: 'ResendInvitation',
    purpose: 'Resend invitation',
    payload: ['user']
  });

  Actions.add({
    name: 'RequestHandled',
    purpose: 'Generic alert that invitation request has been approved or denied',
    payload: ['data']
  });

  Actions.add({
    name: 'SendInvitation',
    purpose: 'Send a user an invitation to join an organization/site',
    payload: ['invitation']
  });

  Actions.add({
    name: 'AddMember',
    purpose: 'Add a member to an organization/site',
    payload: ['member']
  });

  Actions.add({
    name: 'NotEnoughSeats',
    purpose: 'Show dialog warning that org is out of seats',
    payload: []
  });

  return Actions;
};

SettingsActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = SettingsActions;



// WEBPACK FOOTER //
// ./src/app/settings/SettingsActions.js